export class ReportReturnType {
	public bValue: boolean;
	public aGiven: any[];
	public aResult: any[];
	public sIssue: string;
	constructor() {
	}
}